<script lang="ts">
    import {dyData} from 'general/store';

    import s from './style.module.css';

    export let template = 'circle';
    export let side: 'main' | 'subscribed' | 'typ' | 'sms' = 'main';
    export let marginTop = $dyData.radioButton?.marginTop || '0';
    export let marginBottom = '25px';
    export let handleChange: (event: Event) => void = null;
</script>

{#if $dyData.radioButton && $dyData.radioButton[side]}
    <div
        class="{s.wrapper} {s[template] || ''}"
        style="margin-bottom: {marginBottom}; margin-top: {marginTop}"
    >
        {#each $dyData.radioButton[side] as radioButton}
            <label class={s.element}>
                <input
                    class={s.radioButton}
                    checked={radioButton.isChecked}
                    type="radio"
                    name="radioValue"
                    value={radioButton.label}
                    on:change={handleChange}
                />
                <p class={s.label}>{radioButton.label}</p>
            </label>
        {/each}
    </div>
{/if}
